import SDocumentation from './SDocumentation'

export default {
  __init__: ['documentationOverlaysProvider'],
  documentationOverlaysProvider: ['type', SDocumentation],
}
